import { NgModule } from "@angular/core";

import { CustomListDirective } from "./custom-list.directive";

@NgModule({
    declarations: [CustomListDirective],
    exports: [CustomListDirective]
})
export class CustomListModule {}
